import { Controller } from 'stimulus';
import Swiper, {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
} from 'swiper';

class SliderController extends Controller {
  connect() {
    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

    this.swiper = null;
    this.breakpoint = this.data.has('destroy-at')
      ? window.matchMedia(`(min-width: ${this.data.get('destroy-at')}px)`)
      : null;

    if (!this.breakpoint) {
      this.swiper = new Swiper(this.element, this.sliderOptions());
    } else {
      this.setupOnResize();

      window.addEventListener('resize', this.setupOnResize.bind(this));
    }

    this.swiper.on('slideChange', () => {
      if (this.swiper.isBeginning || this.swiper.isEnd) return;

      this.element.classList.remove('reached-beginning');
      this.element.classList.remove('reached-end');
    });

    this.swiper.on('reachBeginning', () => {
      this.element.classList.remove('reached-end');
      this.element.classList.add('reached-beginning');
    });

    this.swiper.on('reachEnd', () => {
      this.element.classList.remove('reached-beginning');
      this.element.classList.add('reached-end');
    });
  }

  setupOnResize() {
    if (this.breakpoint.matches && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    } else if (!this.breakpoint.matches && !this.swiper) {
      this.swiper = new Swiper(this.element, this.sliderOptions());
    }
  }

  sliderOptions() {
    let options = {
      ...this.sliderOptionsFromElement(),

      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },

      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : null,
        type: 'bullets',
      },

      scrollbar: {
        el: this.hasScrollbarTarget ? this.scrollbarTarget : null,
        dragClass: 'swiper__scrollbar-drag',
      },
    };

    if (this.data.has('autoplay')) {
      const delay = this.data.get('autoplay-delay') || 5000;

      options = {
        ...options,

        autoplay: {
          delay,
          disableOnInteraction: false,
        },
      };
    }

    return options;
  }

  sliderOptionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = /^slider/g;

      if (!regex.test(option)) {
        return;
      }

      let value = options[option];
      let transformedOption = option.replace('slider', '');

      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      } else if (/^\d*$/.test(value)) {
        value = parseInt(value, 10);
      } else if (value.startsWith('{')) {
        value = JSON.parse(value);
      } else if (!Number.isNaN(value) && value.indexOf('.') >= 0) {
        value = parseFloat(value);
      }

      config[transformedOption] = value;
    });

    return config;
  }
}

SliderController.targets = [
  'prev',
  'next',
  'slider',
  'scrollbar',
  'pagination',
];

export default SliderController;
